<template>
  <v-layout
    v-if="status"
    class="text-xs-center mt-5"
    justify-center
    align-center
  >
    <v-progress-circular class="text-xs-center" indeterminate color="defaultColor" />
  </v-layout>
</template>

<script>
export default {
  props: {
    status: {
      type: Boolean,
      require: true,
      default: false,
    },
  },
  components: {},
  data: () => ({}),
  computed: {},
};
</script>

<style></style>
